"use client";
import React from "react";
import InlineSVG from "react-inlinesvg";
import clsx from "clsx";

import { COLOR_PRIMARY } from "../../constants/colors";

export interface IProps {
  size?: number;
  id?: string;
  color?: string;
  fill?: string;
  height?: number | string;
  width?: number | string;
  wrapperHeight?: number | string;
  wrapperWidth?: number | string;
  rotate?: number;
  src: string;
  className?: string;
  svgClassName?: string;
  style?: React.CSSProperties;
  disableStyling?: boolean;
}

const generateSize = (value?: number | string) =>
  typeof value === "string" ? value : `${value}px`;

export const SVG = ({
  size = 32,
  rotate = 0,
  color: defaultColor = COLOR_PRIMARY,
  className = "",
  svgClassName = "",
  style = {},
  disableStyling = false,
  ...props
}: IProps) => {
  const wrapperWidth = generateSize(props.wrapperWidth || props.width || size);
  const wrapperHeight = generateSize(
    props.wrapperHeight || props.height || size
  );

  const width = generateSize(props.width || size);
  const height = generateSize(props.height || size);

  const color = disableStyling ? undefined : defaultColor;

  return (
    <div
      className={clsx("inline-flex items-center", className)}
      style={{ width: wrapperWidth, height: wrapperHeight }}
    >
      <InlineSVG
        src={props.src}
        className={clsx(
          !disableStyling &&
            "[&_path]:stroke-current [&_circle]:stroke-current",
          svgClassName
        )}
        style={
          {
            color,
            width,
            height,
            rotate: `${rotate}deg`,
            ...style,
          } as React.CSSProperties
        }
        id={props.id}
      />
    </div>
  );
};
